/**
 * *******************************************************************************************************
 *
 * V1.0
 *
 * User: tomers
 * Date: 5/9/13
 * Visual PDF: https://docs.google.com/a/liveperson.com/file/d/0B7O_LAPhjkbkaHJ0aTVMejFjSmM/edit
 *
 * This plugin is used to implement a common 'edit' link on the right side of a container when hovering the container.
 * Options:
 * el - mandatory. jQuery element. The element on the page where the component will be created. Must be a <DIV> element
 * permutation - optional. One of the options in the static EditDecorator.PERMUTATION enum. PERMUTATION.A is the default
 *
 * Using Example:
 *---------------------------
 * template:
 *<div class="content"> <span>Goal Name</span> </div>
 *
 *  js:
 * this.editContentDecorator = new EditDecorator({
 *      el:$(".content")
 * });
 * this.editContentDecorator.render();
 *
 * *******************************************************************************************************
 */


define(function (require) {
    "use strict";

    var Marionette = require("marionette");
    var Translator = require("i18n/translator");
    var template = require('ui.plugins/edit-decorator/templates/editDecorator.tmpl');
    var Bubble = require("ui/bubble/Bubble");
    var _ = require("underscore");
    var $ = require("jquery");

    var DOUBLE_CLICK_INTERVAL = 500; //in milliseconds

    var EditDecorator = {};

    EditDecorator = Marionette.ItemView.extend({
        version : 1.0,
        template : template,
        withUIComponents: true,
        errorMsg: null,
        contentContainer : null,

        initialize : function (options) {
            this.contentContainer = options.el;
            this.permutation = options.permutation || EditDecorator.PERMUTATION.A;
            this.lastTimeClicked = 0; // used to prevent double click.
            this.enabled = _.has(options, "enabled") ? options.enabled : true;
            this.errorPosition = options.errorPosition || EditDecorator.ERROR_POSITION.BOTTOM;
        },

        events : {
            "click" : "onEditClick",
            "mouseenter":"onContainerMouseEnter",
            "mouseleave":"onContainerMouseLeave"
        },

        render : function () {
            var that = this;
            this.isClosed = false;

            var classByPermutation = this._getClassByPermutation();
            if (this.contentContainer.is("div")) {
                this.contentContainer.addClass("edit-decorator");
                this.contentContainer.addClass(classByPermutation);
                this.contentContainer.append(template);
                this.contentContainer.children().each(function (index, child) {
                    if ($(child).is('.edit-decorator-container')) {
                        return false;
                    }
                    that.contentContainer.find('.edit-decorator-content').append($(child));
                });
                this.contentContainer.find("div.edit span").text(Translator.translate("LEUIComponents.global.edit"));

                this._renderEnabled();
            }

            this.bindUIElements();
            this.triggerMethod("render", this);
            this.triggerMethod("item:rendered", this);

            return this;
        },

        onContainerMouseEnter: function() {
            if (this.contentContainer.hasClass("error") && this.errorMsg) {
                this._closeEditDecoratorError(true);
                this.uiComponents.host$.createAndRender("EditDecoratorError", {
                    type:Bubble,
                    options:{
                        targetControl:this.contentContainer,
                        text:this.errorMsg,
                        position:this.errorPosition,
                        icon:Bubble.ICON.ERROR,
                        showCloseButton:false
                    }
                });
            }
        },

        onContainerMouseLeave: function() {
            this._closeEditDecoratorError();
        },

        _closeEditDecoratorError: function(force) {
            if (this.uiComponents && this.uiComponents.EditDecoratorError) {
                this.uiComponents.EditDecoratorError.close(force);
            }
        },

        setError:function (isError, errorMsg) {
            if (isError) {
                this.contentContainer.addClass("error");
                this.errorMsg = errorMsg;
            }
            else {
                if (typeof this.contentContainer === "object" && "removeClass" in this.contentContainer) {
                    this.contentContainer.removeClass("error");
                    this.errorMsg = null;
                    if (this.uiComponents && this.uiComponents.EditDecoratorError) {
                        this.uiComponents.EditDecoratorError.close();
                    }
                }
            }
        },

        onEditClick : function (event) {
            if (this.enabled) {
                var currentTimestamp = (new Date()).getTime();

                // calculate the time so the callback doesnt run twice. we trigger the event once in the double click interval
                if (currentTimestamp > this.lastTimeClicked + DOUBLE_CLICK_INTERVAL) {
                    this.trigger("click");
                }

                this.lastTimeClicked = currentTimestamp;

                this.setError(false);
            }
        },

        setEnabled : function (mode) {
            this.enabled = mode;
            this._renderEnabled();
        },

        _renderEnabled: function() {
            this.contentContainer.toggleClass("disabled", !this.enabled);
        },

        /**
         * Returns the correct plugin class by its permutation
         * @return {String} - the relevant class to attach to the HTML elements on the page
         * @private
         */
        _getClassByPermutation : function () {
            var retClass = "perm-" + this.permutation;
            return retClass;
        }

    });

    EditDecorator.ERROR_POSITION = Bubble.POSITION;

    // Public ENUM to control
    // The permutation of the edit decorator
    EditDecorator.PERMUTATION = {
        A : 1,
        B : 2
    };

    return EditDecorator;
});

